
import Vue from 'vue';
import LottieAnimation from 'lottie-web-vue';
import success_animation from '@/assets/animations/success.json';

export default Vue.extend({
  data() {
    return {
      success_animation,
    };
  },

  components: {
    LottieAnimation,
  },

  methods: {
    onComplete(): void {
      this.$emit('completed');
    },
  },
});
